import { render, staticRenderFns } from "./ListaAmostras.vue?vue&type=template&id=7544e210&"
import script from "./ListaAmostras.vue?vue&type=script&lang=js&"
export * from "./ListaAmostras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports